import { render, staticRenderFns } from "./BindCompany.vue?vue&type=template&id=a1dec062&"
import script from "./BindCompany.vue?vue&type=script&lang=js&"
export * from "./BindCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports